import LockIcon from '../../public/icons/LockIcon.svg'
import CalendarIcon from '../../public/icons/CalendarIcon.svg'
import InterestsIcon from '../../public/icons/InterestsIcon.svg'
import EmailIcon from '../../public/icons/EmailIcon.svg'
import InformationIcon from '../../public/icons/InformationIcon.svg'
import HighlightIcon from '../../public/icons/HighlightIcon.svg'
import UnderlineIcon from '../../public/icons/UnderlineIcon.svg'
import BookingConfirmedIcon from '../../public/icons/BookingConfirmedIcon.svg'
import ConfirmationIcon from '../../public/icons/Confirmation.svg'
import ConfirmationGreenIcon from '../../public/icons/ConfirmationGreen.svg'
import PaymentIcon from '../../public/icons/PaymentIcon.svg'
import BookingEditIcon from '../../public/icons/BookingEditIcon.svg'
import AustraliaBorderIcon from '../../public/icons/AustraliaBorderIcon.svg'
import AustraliaFilledIcon from '../../public/icons/AustraliaFilledIcon.svg'
import AustraliaOutlineIcon from '../../public/icons/AustraliaOutlineIcon.svg'
import MembershipIcon from '../../public/icons/MembershipIcon.svg'
import GiftIcon from '../../public/icons/GiftIcon.svg'
import ArrowIcon from '../../public/icons/Arrow.svg'
import PhoneRingingIcon from '../../public/icons/PhoneRingingIcon.svg'
import StarOutlineIcon from '../../public/icons/StarOutlineIcon.svg'
import StarIcon from '../../public/icons/StarIcon.svg'
import StarHalfIcon from '../../public/icons/StarHalfIcon.svg'
import BackgroundStrokeIcon from '../../public/icons/BackgroundStrokeIcon.svg'
import CashIcon from '../../public/icons/CashIcon.svg'
import HeartHandsIcon from '../../public/icons/HeartHandsIcon.svg'
import KoalaIcon from '../../public/icons/KoalaIcon.svg'
import TrophyIcon from '../../public/icons/TrophyIcon.svg'
import ShineIcon from '../../public/icons/ShineIcon.svg'
import ArrowCircleIcon from '../../public/icons/ArrowCircleLeftIcon.svg'
import ArrowCircleRightIcon from '../../public/icons/ArrowCircleRightIcon.svg'
import ArrowCircleRightWhiteIcon from '../../public/icons/ArrowCircleRightWhiteIcon.svg'
import ArrowCircleLeftWhiteIcon from '../../public/icons/ArrowCircleLeftWhiteIcon.svg'
import LocationIcon from '../../public/icons/LocationIcon.svg'
import RightArrowIcon from '../../public/icons/RightArrowIcon.svg'
import LeftArrowIcon from '../../public/icons/LeftArrowIcon.svg'
import SearchIcon from '../../public/icons/SearchIcon.svg'
import RefineIcon from '../../public/icons/RefineIcon.svg'
import ShoppingBagIcon from '../../public/icons/ShoppingBagIcon.svg'
import QuestionMarkIcon from '../../public/icons/QuestionMarkIcon.svg'
import QuestionMarkIconWithBlackBG from '../../public/icons/QuestionMarkIconWithBlackBG.svg'
import CloseIcon from '../../public/icons/CloseIcon.svg'
import LinkIcon from '../../public/icons/LinkIcon.svg'
import FlameIcon from '../../public/icons/FlameIcon.svg'
import Koala2Icon from '../../public/icons/Koala2Icon.svg'
import Star from '../../public/icons/Star.svg'
import Bell from '../../public/icons/Bell.svg'
import FacebookIcon from '../../public/icons/FacebookIcon.svg'
import GoogleIcon from '../../public/icons/GoogleIcon.svg'
import SignOutIcon from '../../public/icons/SignOutIcon.svg'
import ThumbUpPlusIcon from '../../public/icons/ThumbUpPlusIcon.svg'
import ThumbsUpIcon from '../../public/icons/ThumbsUpIcon.svg'
import AfterpayLogoIcon from '../../public/icons/AfterpayLogoIcon.svg'
import ChevronDownIcon from '../../public/icons/ChevronDownIcon.svg'
import VelocityPointsIcon from '../../public/icons/VelocityPointsIcon.svg'
import VelocityPointsIconCurrencySymbolRed from '../../public/icons/VelocityPointsIconCurrencySymbolRed.svg'
import HotDealIcon from '../../public/icons/HotDealIcon.svg'
import VelocityPointsCampaign from '../../public/icons/VelocityPointsCampaign.svg'
import HotAirBalloonIcon from '../../public/icons/HotAirBalloonIcon.svg'
import MovieTicketIcon from '../../public/icons/MovieTicketIcon.svg'
import VelocityCurrencyOutlineIcon from '../../public/icons/VelocityCurrencyOutlineIcon.svg'
import ChevronRightIcon from '../../public/icons/ChevronRightIcon.svg'
import ChevronLeftIcon from '../../public/icons/ChevronLeftIcon.svg'
import BusIcon from '../../public/icons/BusIcon.svg'
import StopwatchIcon from '../../public/icons/StopwatchIcon.svg'
import WheelchairIcon from '../../public/icons/WheelchairIcon.svg'
import AusSquareFrame from '../../public/icons/AusSquareFrame.svg'
import AutumnLeafIcon from '../../public/icons/AutumnLeafIcon.svg'
import KeyIcon from '../../public/icons/KeyIcon.svg'
import ReduceWasteIcon from '../../public/icons/ReduceWasteIcon.svg'
import GaugeIcon from '../../public/icons/GaugeIcon.svg'
import RecycleIcon from '../../public/icons/RecycleIcon.svg'
import HoldingHeartIcon from '../../public/icons/HoldingHeartIcon.svg'
import GlobeAustraliaIcon from '../../public/icons/GlobeAustraliaIcon.svg'
import LeafIcon from '../../public/icons/LeafIcon.svg'
import FlowerIcon from '../../public/icons/FlowerIcon.svg'
import ShieldDogIcon from '../../public/icons/ShieldDogIcon.svg'
import EarDeafIcon from '../../public/icons/EarDeafIcon.svg'
import EyeIcon from '../../public/icons/EyeIcon.svg'
import ParkingIcon from '../../public/icons/ParkingIcon.svg'
import WalkingIcon from '../../public/icons/WalkingIcon.svg'
import AccessibleIcon from '../../public/icons/AccessibleIcon.svg'
import PeopleBehindLineIcon from '../../public/icons/PeopleBehindLineIcon.svg'
import AusHomeBannerWaveDesktop from '../../public/icons/HomeBannerWaveDesktop.svg'
import AusHomeBannerWaveMobile from '../../public/icons/HomeBannerWaveMobile.svg'
import NzHomeWaveBannerDesktop from '../../public/icons/HomeBannerWaveDesktopNz.svg'
import NzHomeBannerWaveMobile from '../../public/icons/HomeBannerWaveMobileNz.svg'
import CreditCardErrorIcon from '../../public/icons/CreditCardErrorIcon.svg'
import ConfirmationWhite from '../../public/icons/ConfirmationWhite.svg'
import SantaHatIcon from '../../public/icons/SantaHatIcon.svg'
import MistletoeIcon from '../../public/icons/MistletoeIcon.svg'
import GiftPresentsIcon from '../../public/icons/GiftPresentsIcon.svg'
import CircleTickIcon from '../../public/icons/CircleTickIcon.svg'
import LocationCircleIcon from '../../public/icons/LocationCircleIcon.svg'
import ExclamationCircleIcon from '../../public/icons/ExclamationCircleIcon.svg'
import PersonIcon from '../../public/icons/PersonIcon.svg'
import FilterIcon from '../../public/icons/FilterIcon.svg'
import CaretDownIcon from '../../public/icons/CaretDownIcon.svg'
import PersonFilledIcon from '../../public/icons/PersonFilledIcon.svg'
import ImageIcon from '../../public/icons/ImageIcon.svg'
import CheckmarkCircle from '../../public/icons/CheckmarkCircleIcon.svg'
import PaperPlane from '../../public/icons/PaperPlaneIcon.svg'
import PlusIcon from '../../public/icons/PlusIcon.svg'
import TicketsIcon from '../../public/icons/TicketsIcon.svg'
import ExchangeIcon from '../../public/icons/ExchangeIcon.svg'
import PencilIcon from '../../public/icons/PencilIcon.svg'
import EllipsisIcon from '../../public/icons/EllipsisIcon.svg'
import TickIcon from '../../public/icons/TickIcon.svg'
import ArrowRotateLeftIcon from '../../public/icons/ArrowRotateLeftIcon.svg'
import TicketFilledIcon from '../../public/icons/TicketsFilledIcon.svg'
import MoneyIcon from '../../public/icons/MoneyIcon.svg'
import BlankTicketIcon from '../../public/icons/BlankTicketIcon.svg'
import PencilMoneyIcon from '../../public/icons/PencilMoneyIcon.svg'
import AfterpayIconLogo from '../../public/icons/AfterpayIconLogo.svg'
import ZipLogo from '../../public/icons/ZipLogo.svg'
import ApplePayLogo from '../../public/icons/ApplePayLogo.svg'
import GooglePayLogo from '../../public/icons/GooglePayLogo.svg'
import AmexLogo from '../../public/icons/AmexLogo.svg'
import MasterCardLogo from '../../public/icons/MasterCardLogo.svg'
import VisaLogo from '../../public/icons/VisaLogo.svg'
import AfterpayIconLogoInverse from '../../public/icons/AfterpayIconLogoInverse.svg'
import ZipLogoInverse from '../../public/icons/ZipLogoInverse.svg'
import ApplePayLogoInverse from '../../public/icons/ApplePayLogoInverse.svg'
import GooglePayLogoInverse from '../../public/icons/GooglePayLogoInverse.svg'
import AmexLogoInverse from '../../public/icons/AmexLogoInverse.svg'
import MasterCardLogoInverse from '../../public/icons/MasterCardLogoInverse.svg'
import VisaLogoInverse from '../../public/icons/VisaLogoInverse.svg'
import ChatIcon from '../../public/icons/ChatIcon.svg'
import InfoFilled from '../../public/icons/InfoFilled.svg'
import SortIcon from '../../public/icons/SortIcon.svg'

export type IconName =
  | 'lock'
  | 'calendar'
  | 'interests'
  | 'email'
  | 'info'
  | 'highlight'
  | 'underline'
  | 'australia'
  | 'australiaFilled'
  | 'australiaOutline'
  | 'bookingConfirmed'
  | 'bookingEdit'
  | 'payment'
  | 'membership'
  | 'gift'
  | 'arrow'
  | 'phoneRinging'
  | 'starOutline'
  | 'star'
  | 'starHalf'
  | 'backgroundStroke'
  | 'cash'
  | 'heartHands'
  | 'koala'
  | 'trophy'
  | 'shine'
  | 'arrowCircleLeft'
  | 'arrowCircleRight'
  | 'arrowCircleRightWhite'
  | 'arrowCircleLeftWhite'
  | 'location'
  | 'rightarrow'
  | 'leftArrow'
  | 'search'
  | 'refine'
  | 'shoppingBag'
  | 'question'
  | 'questionMarkBlackBG'
  | 'close'
  | 'link'
  | 'flame'
  | 'koala2'
  | 'starIcon'
  | 'bell'
  | 'confirmation'
  | 'facebook'
  | 'google'
  | 'signOut'
  | 'thumbUpPlus'
  | 'thumbsUp'
  | 'afterpayLogo'
  | 'chevronDown'
  | 'velocityPoints'
  | 'velocityPointsWhite'
  | 'hotDeal'
  | 'velocityCampaign'
  | 'hotairBalloon'
  | 'movieTicket'
  | 'velocityCurrentOutline'
  | 'chevronRightIcon'
  | 'chevronLeftIcon'
  | 'bus'
  | 'stopwatch'
  | 'wheelchair'
  | 'ausSquareFrame'
  | 'autumnLeaf'
  | 'key'
  | 'reduceWaste'
  | 'gauge'
  | 'recycle'
  | 'holdingHeart'
  | 'globeAustralia'
  | 'leaf'
  | 'flower'
  | 'shieldDog'
  | 'earDeaf'
  | 'eye'
  | 'parking'
  | 'walking'
  | 'accessible'
  | 'behindLine'
  | 'homeBannerWaveDesktopAu'
  | 'homeBannerWaveMobileAu'
  | 'homeBannerDesktopNz'
  | 'homeBannerMobileNz'
  | 'creditCardError'
  | 'confirmationGreen'
  | 'confirmationWhite'
  | 'santaHat'
  | 'mistletoe'
  | 'giftPresents'
  | 'circleTick'
  | 'locationCircle'
  | 'exclamationCircle'
  | 'person'
  | 'filter'
  | 'caretDown'
  | 'personFilled'
  | 'image'
  | 'checkmarkCircle'
  | 'paperPlane'
  | 'plus'
  | 'tickets'
  | 'exchange'
  | 'pencil'
  | 'ellipsis'
  | 'tick'
  | 'arrowRotateLeft'
  | 'ticketFilled'
  | 'money'
  | 'blankTicket'
  | 'pencilMoney'
  | 'afterpayIcon'
  | 'zip'
  | 'applePay'
  | 'googlePay'
  | 'amex'
  | 'mastercard'
  | 'visa'
  | 'afterpayIconInverse'
  | 'zipInverse'
  | 'applePayInverse'
  | 'googlePayInverse'
  | 'amexInverse'
  | 'mastercardInverse'
  | 'visaInverse'
  | 'chat'
  | 'infoFilled'
  | 'sort'

const icons: Record<IconName, string> = {
  lock: LockIcon,
  calendar: CalendarIcon,
  interests: InterestsIcon,
  email: EmailIcon,
  info: InformationIcon,
  highlight: HighlightIcon,
  underline: UnderlineIcon,
  australia: AustraliaBorderIcon,
  australiaFilled: AustraliaFilledIcon,
  australiaOutline: AustraliaOutlineIcon,
  bookingConfirmed: BookingConfirmedIcon,
  bookingEdit: BookingEditIcon,
  payment: PaymentIcon,
  membership: MembershipIcon,
  gift: GiftIcon,
  arrow: ArrowIcon,
  phoneRinging: PhoneRingingIcon,
  starOutline: StarOutlineIcon,
  star: StarIcon,
  starHalf: StarHalfIcon,
  backgroundStroke: BackgroundStrokeIcon,
  cash: CashIcon,
  heartHands: HeartHandsIcon,
  koala: KoalaIcon,
  trophy: TrophyIcon,
  shine: ShineIcon,
  arrowCircleLeft: ArrowCircleIcon,
  arrowCircleRight: ArrowCircleRightIcon,
  location: LocationIcon,
  rightarrow: RightArrowIcon,
  leftArrow: LeftArrowIcon,
  search: SearchIcon,
  refine: RefineIcon,
  shoppingBag: ShoppingBagIcon,
  question: QuestionMarkIcon,
  questionMarkBlackBG: QuestionMarkIconWithBlackBG,
  close: CloseIcon,
  link: LinkIcon,
  flame: FlameIcon,
  koala2: Koala2Icon,
  starIcon: Star,
  bell: Bell,
  confirmation: ConfirmationIcon,
  facebook: FacebookIcon,
  google: GoogleIcon,
  signOut: SignOutIcon,
  thumbUpPlus: ThumbUpPlusIcon,
  thumbsUp: ThumbsUpIcon,
  afterpayLogo: AfterpayLogoIcon,
  chevronDown: ChevronDownIcon,
  arrowCircleRightWhite: ArrowCircleRightWhiteIcon,
  arrowCircleLeftWhite: ArrowCircleLeftWhiteIcon,
  velocityPoints: VelocityPointsIconCurrencySymbolRed,
  velocityPointsWhite: VelocityPointsIcon,
  hotDeal: HotDealIcon,
  velocityCampaign: VelocityPointsCampaign,
  hotairBalloon: HotAirBalloonIcon,
  movieTicket: MovieTicketIcon,
  velocityCurrentOutline: VelocityCurrencyOutlineIcon,
  chevronRightIcon: ChevronRightIcon,
  chevronLeftIcon: ChevronLeftIcon,
  bus: BusIcon,
  stopwatch: StopwatchIcon,
  wheelchair: WheelchairIcon,
  ausSquareFrame: AusSquareFrame,
  autumnLeaf: AutumnLeafIcon,
  key: KeyIcon,
  reduceWaste: ReduceWasteIcon,
  gauge: GaugeIcon,
  recycle: RecycleIcon,
  holdingHeart: HoldingHeartIcon,
  globeAustralia: GlobeAustraliaIcon,
  leaf: LeafIcon,
  flower: FlowerIcon,
  shieldDog: ShieldDogIcon,
  earDeaf: EarDeafIcon,
  eye: EyeIcon,
  parking: ParkingIcon,
  walking: WalkingIcon,
  accessible: AccessibleIcon,
  behindLine: PeopleBehindLineIcon,
  homeBannerWaveDesktopAu: AusHomeBannerWaveDesktop,
  homeBannerWaveMobileAu: AusHomeBannerWaveMobile,
  homeBannerDesktopNz: NzHomeWaveBannerDesktop,
  homeBannerMobileNz: NzHomeBannerWaveMobile,
  creditCardError: CreditCardErrorIcon,
  confirmationGreen: ConfirmationGreenIcon,
  confirmationWhite: ConfirmationWhite,
  santaHat: SantaHatIcon,
  mistletoe: MistletoeIcon,
  giftPresents: GiftPresentsIcon,
  circleTick: CircleTickIcon,
  locationCircle: LocationCircleIcon,
  exclamationCircle: ExclamationCircleIcon,
  person: PersonIcon,
  filter: FilterIcon,
  caretDown: CaretDownIcon,
  personFilled: PersonFilledIcon,
  image: ImageIcon,
  checkmarkCircle: CheckmarkCircle,
  paperPlane: PaperPlane,
  plus: PlusIcon,
  tickets: TicketsIcon,
  exchange: ExchangeIcon,
  pencil: PencilIcon,
  ellipsis: EllipsisIcon,
  tick: TickIcon,
  arrowRotateLeft: ArrowRotateLeftIcon,
  ticketFilled: TicketFilledIcon,
  money: MoneyIcon,
  blankTicket: BlankTicketIcon,
  pencilMoney: PencilMoneyIcon,
  afterpayIcon: AfterpayIconLogo,
  zip: ZipLogo,
  applePay: ApplePayLogo,
  googlePay: GooglePayLogo,
  amex: AmexLogo,
  mastercard: MasterCardLogo,
  visa: VisaLogo,
  afterpayIconInverse: AfterpayIconLogoInverse,
  zipInverse: ZipLogoInverse,
  applePayInverse: ApplePayLogoInverse,
  googlePayInverse: GooglePayLogoInverse,
  amexInverse: AmexLogoInverse,
  mastercardInverse: MasterCardLogoInverse,
  visaInverse: VisaLogoInverse,
  chat: ChatIcon,
  infoFilled: InfoFilled,
  sort: SortIcon,
}

type IconProps = {
  name: IconName
  color?: string
  [propName: string]: any
}

const Icon: React.FC<IconProps> = ({ name, color, ...props }) => {
  const Component = icons[name]
  return <Component {...props} />
}

export default Icon
